import type { EventReminder } from 'models';
import { useCallback } from 'react';
import { useGetReminderDateTime } from '../../../components';
import type { DuplicateEventRequestData } from '../../../queries';
import type { DuplicateReminderFormValues } from '../DuplicateReminderForm';

export const useCreateFormRequestData = () => {
  const getReminderDateTime = useGetReminderDateTime();

  return useCallback(
    (formValues: DuplicateReminderFormValues, event: EventReminder): DuplicateEventRequestData => {
      const { endTime, startTime } = getReminderDateTime(formValues);

      return {
        data: {
          allDay: formValues.isAllDay,
          distributionList: formValues.duplicateInviteesFromEvent ? event.distributionList : undefined,
          endTime: endTime.toISOString(),
          html: formValues.htmlDescription,
          name: formValues.name,
          startTime: startTime.toISOString(),
          text: formValues.textDescription,
          type: 'reminder',
        },
        duplicateParticipantsFrom: formValues.duplicateInviteesFromEvent ? event.id : undefined,
      };
    },
    [getReminderDateTime],
  );
};
